import { API_USER_URL } from "@/env";
import { message } from "antd";
import { CashflowChartAPI, DashboardSummaryAPI, OverdueDataAPI, PackageComparisonAPI, ProfitChartAPI, RevenueChartAPI } from "./type";

const API_USE = API_USER_URL || '';

async function dashboardSummary(fromDate: string, toDate: string): Promise<DashboardSummaryAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }
    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/dashboard/summary?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch dashboard summary');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        message.error('Lỗi khi lấy thông tin tổng quan');
        throw error;
    }
}

async function cashflowChartData(fromDate: string, toDate: string): Promise<CashflowChartAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }
    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/dashboard/cash?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch cashflow chart data');
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        message.error('Lỗi khi lấy dữ liệu biểu đồ dòng tiền');
        throw error;
    }
}

async function packageComparisonData(fromDate: string, toDate: string): Promise<PackageComparisonAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/dashboard/packages?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch package comparison data');
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        message.error('Lỗi khi lấy dữ liệu so sánh gói');
        throw error;
    }
}

async function profitChartData(fromDate: string, toDate: string): Promise<ProfitChartAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }
    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/dashboard/profit?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch profit chart data');
        }   
        const data = await response.json();
        return data;
    } catch (error) {
        message.error('Lỗi khi lấy dữ liệu biểu đồ lợi nhuận');
        throw error;
    }
}

async function revenueChartData(fromDate: string, toDate: string): Promise<RevenueChartAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }
    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/dashboard/revenue?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch revenue chart data');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        message.error('Lỗi khi lấy dữ liệu biểu đồ doanh thu');
        throw error;
    }
}

async function overdueData(fromDate: string, toDate: string, page: number = 1, perPage: number = 12): Promise<OverdueDataAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }
    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/dashboard/overdue?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&page=${page}&per_page=${perPage}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch overdue data');
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        message.error('Lỗi khi lấy dữ liệu quá hạn');
        throw error;
    }
}

export {
    dashboardSummary,
    cashflowChartData,
    packageComparisonData,
    profitChartData,
    revenueChartData,
    overdueData
}